import Vue from 'vue'
import Vuex from 'vuex'

import modalStore from './modalStore'
import userFbStore from './userFbStore'
import alertStore from './alertStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    modalStore,
    userFbStore,
    alertStore
  }
})
